import { defineMessages } from 'react-intl'

const messages = defineMessages({
  signupForOurNewsletter: {
    id: 'newsletter.signupForOurNewsletter',
    defaultMessage: 'Anmäl dig till vårt nyhetsbrev',
  },
  register: {
    id: 'newsletter.register',
    defaultMessage: 'Registrera',
  },
  useValidEmail: {
    id: 'newsletter.useValidEmail',
    defaultMessage: 'Använd en godkänd email',
  },
  someThingWentWrong: {
    id: 'newsletter.someThingWentWrong',
    defaultMessage: 'Något gick fel. Försk med en annan email',
  },
})

export default messages
